import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  Batch,
  Team,
  User,
  Campus
} from '../../../shared';

class PasswordFormModel {
  password: string;
  repeatedPassword: string;
}

@Component({
  selector: 'app-update-password-card',
  templateUrl: './update-password-card.component.html',
  styleUrls: ['./update-password-card.component.css']
})
export class UpdatePasswordCardComponent implements OnInit {
  @Input() user: User;
  @Input() team: Team;
  @Input() batch: Batch;
  @Input() campus: Campus;
  @Output() updatePassword: EventEmitter<string> = new EventEmitter();
  passwordFormModel: PasswordFormModel;

  constructor() { }

  ngOnInit() {
    this.passwordFormModel = new PasswordFormModel();
  }

  onUpdatePassword() {
    this.updatePassword.emit(this.passwordFormModel.password);
  }

  arePasswordsMatch(): boolean {
    return this.passwordFormModel.password === this.passwordFormModel.repeatedPassword
  }
}



// WEBPACK FOOTER //
// ./src/app/me/components/update-password-card/update-password-card.component.ts